import { connect } from 'dva';
import { useState } from 'react';
import router from 'umi/router';
import styles from './orderInfo.less';
import addPng from 'images/addPng.png';
import reducePng from 'images/reducePng.png';
import { btnBackgroundColor, btnTextColor } from 'utils/theme';

const OrderInfo = (props = {}) => {
  const { location, global } = props;
  const query = (location && location.query) || {};
  const channel = query.channel || global.channel;
  const POINT_MONEY = global.POINT_MONEY || 160;
  const dragoncode = query.dragoncode || global.dragoncode || localStorage.getItem('dragoncode');
  console.log('channel', channel, global);
  const [num, setNum] = useState(1); // 数量
  // 操作数量
  const onOperateNum = (type) => {
    const operateObj = {
      // 增加
      add: () => {
        setNum(num + 1);
      },
      // 减少
      reduce: () => {
        if (num > 1) {
          setNum(num - 1);
        }
      },
    };
    operateObj[type]();
  };

  // 去支付
  const onPay = () => {
    router.push({
      pathname: '/pay',
      query: {
        phontNum: num,
      },
    });
  };

  return (
    <div>
      <div className={styles.main}>
        <div className={styles.title}>订单信息</div>
        <ul className={styles.orderInfoList}>
          <li>
            <div className={styles.left}>龙腾卡号</div>
            <div className={styles.right}>{dragoncode}</div>
          </li>
          <li>
            <div className={styles.left}>单价</div>
            <div className={styles.right}>￥{POINT_MONEY}元/人次</div>
          </li>
          <li>
            <div className={styles.left}>购买人次</div>
            <div className={styles.right}>
              <div className={styles.numOperate}>
                <img src={reducePng} alt="" onClick={() => onOperateNum('reduce')} />
                <span>{num}</span>
                <img src={addPng} alt="" onClick={() => onOperateNum('add')} />
              </div>
            </div>
          </li>
          <li>
            <div className={styles.left}>订单金额</div>
            <div className={styles.right}>￥{num * POINT_MONEY}元</div>
          </li>
        </ul>
      </div>
      <div className={styles.footer}>
        <div className={styles.payMoney}>
          应付金额<span>￥{num * POINT_MONEY}.0 </span>
        </div>
        <div
          className={styles.payBtn}
          style={{ background: btnBackgroundColor[channel], color: btnTextColor[channel] }}
          onClick={onPay}
        >
          去支付
        </div>
      </div>
    </div>
  );
};
export default connect(({ global }) => {
  return { global };
})(OrderInfo);
